"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.form.back': 'Atrás',
    'profession.form.name.label': 'Nombre',
    'profession.form.name.placeholder': 'Nombre de la profesión',
    'profession.form.branch.label': 'Rama',
    'profession.form.branch.placeholder': 'Seleccionar rama',
    'profession.form.description.label': 'Descripción',
    'profession.form.description.placeholder': 'Ingrese la descripción de la profesión',
    'profession.form.common.label': 'Común',
    'profession.form.image.label': 'Imagen',
    'profession.form.knowledge.label': 'Entradas de Conocimiento',
    'profession.form.knowledge.title': 'Entradas de Conocimiento',
    'profession.form.steps.title': 'Pasos',
    'profession.form.steps.label': 'Seleccionar Pasos',
    'profession.form.submit.label': 'Enviar',
    'profession.form.active.label': 'Activo',
    'profession.form.knowledge.placeholder': 'Buscar entradas de conocimiento...',
    'profession.form.branches.load.error': 'Error al cargar ramas',
    'profession.form.steps.load.error': 'Error al cargar pasos',
    'profession.form.load.error': 'Error al cargar profesión',
    'profession.form.update.success': 'Profesión actualizada exitosamente',
    'profession.form.action.success': 'Profesión',
    'profession.form.action.error': 'La profesión no pudo ser',
    'profession.form.action.failed': 'Error al',
    'profession.form.update': 'actualizar',
    'profession.form.create': 'crear',
};
